/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useGlobalStore, useUserStore } from '@shared/store';
import { storeToRefs } from 'pinia';
import queryString from 'query-string';

/**
 * 将查询参数转换成json对象
 * @param url url查询参数，可不传，不传读取当前location.search
 * @returns url查询参数JSON对象
 *  searchToJson('?a=undefined&b=2')  输出{a: '', b: '2'}
 */
export const searchToJson = (url?: string): TLooseStrObj => {
  let search = url || location.search;

  if (search?.indexOf('?') === -1) {
    //url里没有？的
    return {};
  } else {
    search = '?' + search?.split('?')[1]; // 必须截取出值
  }

  const urlParams = new URLSearchParams(search);
  return [...urlParams.entries()].reduce((obj: TLooseStrObj, [key, val]) => {
    obj[key] = val === 'undefined' || val === 'null' ? '' : val;
    return obj;
  }, {});
};

/** 将json转换为url的search部分
 *  @param json:Object
 * jsonToSearch({a:2,b:3,c:4})  输出'?a=2&b=3&c=4'
 */
export const jsonToSearch = (json = {}) => {
  return `?${new URLSearchParams(json).toString()}`;
};

/**
 * [changeSearch description]
 * @param  {string} key 需要修改的search字段
 * @param  {string} newVal 替换的新串
 * @param  {string} url 当前要替换的link地址  不传默认是   location.href
 * @return {string}         [description]
 */

export const changeSearch = (key: string, newVal: string, url?: string) => {
  const newUrl = url || location.href;
  if (!key) {
    return newUrl;
  }

  if (newUrl?.indexOf('?') !== -1) {
    const obj = searchToJson(url);
    obj[key] = newVal;
    return newUrl.split('?')[0] + jsonToSearch(obj);
  } else {
    return `${newUrl}?${key}=${newVal}`;
  }
};

/**
 * 改变history跳转参数  add  currentCorpId  为了如果复制了链接发送的客户  不至于页面丢失企业数据
 * @param  {string} path
 * @param  {string} staffId
 */
export const withCurrentCorpIdStaffIdPath = (path: string, staffId?: string): string => {
  try {
    const globalStore = useGlobalStore();
    const userStore = useUserStore();
    const { appData } = storeToRefs(globalStore);
    const { viewStaffInfo } = storeToRefs(userStore);
    const searchObj = queryString.parse(location.search) || {}; // 兼容：globalStore 取不到 currentCorpId, agentId 时，则从链接取相关数据
    const baseLinkInfo = {
      currentCorpId: appData.value?.currentCorpId || searchObj?.currentCorpId,
      agentId: appData.value?.agentId || searchObj?.agentId,
      suiteId: appData.value?.suiteId || searchObj?.suiteId,
      staffId: staffId || viewStaffInfo.value?.staffId || searchObj?.staffId,
    };
    const url = `${path}${path.includes('?') ? '&' : '?'}${jsonToSearch(baseLinkInfo).replace('?', '')}`;
    return url;
  } catch (error) {
    console.log(error);
    return null;
  }
};
/**
 * 获取url的指定参数
 * @param {*} name 参数名称
 * @param {*} url 需要处理的url,可不传,url兼容全路径。
 */
export const getQueryString = (name: string, url = '') => {
  let search = url || location.search;

  if (search?.indexOf('?') === -1) {
    //url里没有？的
    return '';
  } else {
    search = '?' + search?.split('?')[1]; // 必须截取出值,兼容全路径
  }
  return new URLSearchParams(search).get(name) || '';
};

/**
 * 链接加参数
 * @param  {string} path 路径
 * @param  {string} keyName 参数名
 * @param  {string} value 参数值
 * @return {string} value      [description]
 */
export const addSearchParam = (path: string, keyName: string, value: string) => {
  const url = `${path}${path.includes('?') ? '&' : '?'}${keyName}=${value}`;
  return url;
};
